import React, { useEffect, useState } from "react";
import doctor01 from "../../assets/UserPanelAssets/img/doctors/doctor-01.jpg";
import doctor02 from "../../assets/UserPanelAssets/img/doctors/doctor-02.jpg";
import doctor03 from "../../assets/UserPanelAssets/img/doctors/doctor-03.jpg";
import doctor04 from "../../assets/UserPanelAssets/img/doctors/doctor-04.jpg";

import Tables from "../Components/UserPanelDataTables/tables";

export default function Prescriptions() {
  const [data, setData] = useState([]);
  useEffect(() => {
    setData({
      head: [
        { key: "prescriptionId", label: "Prescription ID" },
        { key: "doctorInfo", label: "Doctor Name" },
        { key: "date", label: "Prescribed On" },
        { key: "actions", label: "" },
      ],

      rows: [
        {
          prescriptionId: "#PRE0025",
          doctorInfo: {
            doctorImage: doctor01,
            doctorName: "Dr. Mick Thompson",
            specialty: "Cardiologist",
            doctorLink: "/patients-doctor-details",
          },
          date: "30 Apr 2025",
          actions: [
            {
              label: "View",
              type: "dropdown",
              link: "/patient-prescription-details",
            },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },

        {
          prescriptionId: "#PRE0026",
          doctorInfo: {
            doctorImage: doctor02,
            doctorName: "Dr. Sarah Johnson",
            specialty: "Orthopedic Surgeon",
            doctorLink: "/patients-doctor-details",
          },
          date: "15 May 2025",
          actions: [
            {
              label: "View",
              type: "dropdown",
              link: "/patient-prescription-details",
            },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },

        {
          prescriptionId: "#PRE0027",
          doctorInfo: {
            doctorImage: doctor03,
            doctorName: "Dr. Emily Carter",
            specialty: "Pediatrician",
            doctorLink: "/patients-doctor-details",
          },
          date: "02 Jun 2025",
          actions: [
            {
              label: "View",
              type: "dropdown",
              link: "/patient-prescription-details",
            },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },

        {
          prescriptionId: "#PRE0028",
          doctorInfo: {
            doctorImage: doctor04,
            doctorName: "Dr. David Lee",
            specialty: "Gynecologist",
            doctorLink: "/patients-doctor-details",
          },
          date: "18 Jun 2025",
          actions: [
            {
              label: "View",
              type: "dropdown",
              link: "/patient-prescription-details",
            },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },
      ],
    });
  }, []);

  return (
    <div className="content">
      {/* Page Header */}
      <div className="d-flex align-items-sm-center flex-sm-row flex-column gap-2 pb-3 mb-3 border-1 border-bottom">
        <div className="flex-grow-1">
          <h4 className="fw-bold mb-0">Prescription</h4>
        </div>

        <div className="text-end">
          <div className="dropdown me-1">
            <a
              href="javascript:void(0);"
              className="btn btn-md border fs-14 fw-normal bg-white rounded text-dark d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              Export<i className="ti ti-chevron-down ms-2"></i>
            </a>

            <ul className="dropdown-menu p-2">
              <li>
                <a className="dropdown-item" href="#">
                  Download as PDF
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  Download as Excel
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Filters Row */}
      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
        <div className="search-set mb-3">
          <div className="d-flex align-items-center flex-wrap gap-2">
            <div className="table-search d-flex align-items-center mb-0">
              <div className="search-input">
                <a href="javascript:void(0);" className="btn-searchset"></a>
              </div>
            </div>
          </div>
        </div>

        {/* Sorting + Filters */}
        <div className="d-flex table-dropdown mb-3 pb-1 right-content align-items-center flex-wrap row-gap-3">
          {/* Filters */}
          <div className="dropdown me-2">
            <a
              href="javascript:void(0);"
              className="bg-white border rounded btn btn-md text-dark fs-14 py-1 align-items-center d-flex fw-normal"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
            >
              <i className="ti ti-filter text-gray-5 me-1"></i>Filters
            </a>

            <div className="dropdown-menu dropdown-lg dropdown-menu-end filter-dropdown p-0">
              <div className="d-flex align-items-center justify-content-between border-bottom filter-header">
                <h4 className="mb-0 fw-bold">Filter</h4>
                <a
                  href="javascript:void(0);"
                  className="link-danger text-decoration-underline"
                >
                  Clear All
                </a>
              </div>

              {/* Filter Body */}
              <form>
                <div className="filter-body pb-0">
                  {/* Doctor Filter */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label mb-1">Doctor</label>
                      <a
                        href="javascript:void(0);"
                        className="link-primary mb-1"
                      >
                        Reset
                      </a>
                    </div>
                    <select className="select2" multiple>
                      <option value="1" selected>
                        Dr. Mick Thompson
                      </option>
                      <option value="2">Dr. Sarah Johnson</option>
                      <option value="3">Dr. Emily Carter</option>
                      <option value="4">Dr. David Lee</option>
                      <option value="5">Dr. Anna Kim</option>
                    </select>
                  </div>

                  {/* Designation Filter */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label">Designation</label>
                      <a
                        href="javascript:void(0);"
                        className="link-primary mb-1"
                      >
                        Reset
                      </a>
                    </div>
                    <select className="select2" multiple>
                      <option selected>Cardiologist</option>
                      <option>Orthopedic Surgeon</option>
                      <option>Pediatrician</option>
                      <option>Gynecologist</option>
                    </select>
                  </div>

                  {/* Department */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label">Department</label>
                      <a
                        href="javascript:void(0);"
                        className="link-primary mb-1"
                      >
                        Reset
                      </a>
                    </div>
                    <select className="select2" multiple>
                      <option selected>Cardiology</option>
                      <option>Orthopedics</option>
                      <option>Pediatrics</option>
                    </select>
                  </div>

                  {/* Date */}
                  <div className="mb-3">
                    <label className="form-label mb-1 text-dark fs-14 fw-medium">
                      Date<span className="text-danger">*</span>
                    </label>
                    <div className="input-icon-end position-relative">
                      <input
                        type="text"
                        className="form-control datetimepicker"
                        placeholder="dd/mm/yyyy"
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar"></i>
                      </span>
                    </div>
                  </div>

                  {/* Amount */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label">Amount</label>
                      <a
                        href="javascript:void(0);"
                        className="link-primary mb-1"
                      >
                        Reset
                      </a>
                    </div>
                    <select className="select2" multiple>
                      <option selected>$501 - $1000</option>
                      <option>$501 - $1100</option>
                      <option>$701 - $1200</option>
                    </select>
                  </div>

                  {/* Status */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label">Status</label>
                      <a
                        href="javascript:void(0);"
                        className="link-primary mb-1"
                      >
                        Reset
                      </a>
                    </div>
                    <select className="select2" multiple>
                      <option selected>Available</option>
                      <option>Unavailable</option>
                    </select>
                  </div>
                </div>

                <div className="filter-footer d-flex align-items-center justify-content-end border-top">
                  <a
                    href="javascript:void(0);"
                    className="btn btn-light btn-md me-2 fw-medium"
                  >
                    Close
                  </a>
                  <button
                    type="submit"
                    className="btn btn-primary btn-md fw-medium"
                  >
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Sorting */}
          <div className="dropdown">
            <a
              href="javascript:void(0);"
              className="dropdown-toggle btn bg-white btn-md d-inline-flex align-items-center fw-normal rounded border text-dark px-2 py-1 fs-14"
              data-bs-toggle="dropdown"
            >
              <span className="me-1">Sort By :</span> Recent
            </a>

            <ul className="dropdown-menu dropdown-menu-end p-2">
              <li>
                <a className="dropdown-item">Recently Added</a>
              </li>
              <li>
                <a className="dropdown-item">Ascending</a>
              </li>
              <li>
                <a className="dropdown-item">Descending</a>
              </li>
              <li>
                <a className="dropdown-item">Last Month</a>
              </li>
              <li>
                <a className="dropdown-item">Last 7 Days</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Table */}
      <Tables data={data} />
    </div>
  );
}
